package de.oevbs.kunde.kundenportal2.model.services.contact

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class ContactClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle Daten aus dem CRM, die zur Initialisierung des Mitteilungs-Bereiches im Kundenportal notwendig sind:
     * den Berater, eine Liste der Schäden und eine Liste der Verträge des Kunden.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<ContactMessageInit> = get("/contact/init")


    /**
     * Sendet die übergebene Nachricht je nach Nachrichten-Typ an die richtigen Empfänger ab.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun send(contactMessage: ContactMessage): ClientResponse<Unit> = post("/contact/send", contactMessage)

}